import Moment from 'moment';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { enrollmentStatus } from '../../../../models/enums/enrollmentStatus';
import { enrollmentAddActionLog } from '../../../../store/actions/enrollment';
import { getCourseContentsWeekActivitiesAction, SetUpdateInput } from '../../../../store/actions/coursePage';
import ProgressCircle from '../../../progress-circle/progress-circle';
import ProcessingActivity from '../activity-proccessing/processing-activity';
import { UserType } from '../../../../models/enums/userType';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import EdiText from 'react-editext';
import { CoursePageService } from '../../../../api/course-page-service';
import { IActivityCard } from '../../../../models/components/activity-card';
import * as Actions from '../../../../store/actions/coursePage';
import ReactGA from 'react-ga4';
import ProgressCircleStudent from '../../../progress-circle/progress-circle-student';
import PdfPreview from '../../../previews/pdf/main';
import { Notification } from '../../../notification/main';
import Tooltip from '../../../tooltip/main';
import Truncater from '../../../truncater/main';



const T = Translator.create();
let _common: Common;
const coursePageService = new CoursePageService();
const _logger = Log.create('DocumentActivityCard');
const maxEditTextLength = 56;


class DocumentActivityCard extends React.Component<ISignleActivityCard> {
    public state = {
        activityCardImage: '', isPDFViewerModalOpen: false,
        editTextValue:
            this.props.activityCard!.name!.toString().length > maxEditTextLength
                ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                : this.props.activityCard!.name!.toString(),
        editTextHandleValue: this.props.activityCard!.name!.toString(),
        nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1,
        isModalOpen: false,
        selectedFile: { name: "", path: "" }
    };
    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
        this.clickViewComplete = this.clickViewComplete.bind(this);
        this.afterSave = this.afterSave.bind(this);
    }

    public componentDidMount(): void {
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true })
        }
    }

    componentDidUpdate(prevProps: Readonly<ISignleActivityCard>, prevState: Readonly<{}>, snapshot?: any): void {
        if (this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks && this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true })
        }
    }

    public clickViewComplete = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_COMPLETE_ACTIVITY_CLICKED',
            label: 'G_COMPLETE_ACTIVITY_CLICKED',
            nonInteraction: true,
        });
        if (
            ((this.props.activityCard!.enrollmentStatus &&
                this.props.activityCard!.enrollmentStatus !== enrollmentStatus.Completed) || !this.props.activityCard!.enrollmentStatus) &&
            this.props.activityCard!.completionType === ActivityCompletionType.View) {
            this.props.dispatch(
                enrollmentAddActionLog({
                    ActivityCompletionType: ActivityCompletionType.View,
                    ActivityId: this.props.activityCard!.activityId!,
                    EnrollmentId: this.props.activityCard!.enrollmentId!,
                    ClassId: this.props.classId
                })
            );
        } else if (((this.props.activityCard!.enrollmentStatus &&
            this.props.activityCard!.enrollmentStatus !== enrollmentStatus.Completed) || !this.props.activityCard!.enrollmentStatus) &&
            this.props.activityCard!.completionType === ActivityCompletionType.DownloadAttachment) {
            this.props.dispatch(
                enrollmentAddActionLog({
                    ActivityCompletionType: ActivityCompletionType.DownloadAttachment,
                    ActivityId: this.props.activityCard!.activityId!,
                    EnrollmentId: this.props.activityCard!.enrollmentId!,
                    ClassId: this.props.classId
                })
            );
        }

    }

    triggerGetCoursContent = () => {
        if (this.props.coursePageClassId && this.props.coursePageActivityId) {
            this.props.dispatch(Actions.getCourseContentsWeekActivitiesAction(
                this.props.coursePageClassId,
                this.props.coursePageActivityId,
                false,
                0,
                1000,
                this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
                false,
                false,
                null,
                'contentWeekActivities',
                'get',
                false,
                this.props.activityFilters.sort!));
        }
    }

    getActivities = (filters: any) => {
        let hasFilters = filters.hasFilters;
        const weekOrUnitId = this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId;
        const param: IActivityCard = {
            actId: '',
            coursePageClassId: this.props.coursePageClassId,
            coursePageActivityId: this.props.coursePageActivityId,
            courseContentTermWeeks: this.props.courseContentTermWeeks,
            hasFilter: filters.hasFilter,
            activityFilters: filters,
            GetOnlyPassiveList: this.props.activityFilters.GetOnlyPassiveList ? this.props.activityFilters.GetOnlyPassiveList : false,
            weekOrUnitId: hasFilters ? '-1' : weekOrUnitId,
            courseContentMenuType: this.props.courseContentMenuType,
            sort: this.props.activityFilters.sort!,
            activeStatus: hasFilters ? this.props.activityFilters.statusFilter : null,
            courseContentWeekActivities: this.props.courseContentWeeksActivities
        };
        this.props.dispatch(Actions.SetTriggerGetActivities(param, undefined, "SetTriggerGetActivities", 'get', this.props.courseDefaultView, this.state.nonWeeklyCourse));
    }

    onFilter = () => {
        setTimeout(() => {
            if (this.props.coursePageClassId && this.props.coursePageActivityId) {
                const _filters = this.props.activityFilters;
                if (this.props.activityFilters && (this.props.activityFilters.searchedText || (this.props.activityFilters.selectedActivityTypes && this.props.activityFilters.selectedActivityTypes.length > 0))) {
                    _filters.hasFilter = true;
                    _filters.sort = this.props.activityFilters.sort!;
                    this.setState({ filters: _filters, isLoading: false });
                    this.getActivities(_filters)

                } else {
                    _filters.hasFilter = false;
                    _filters.sort = this.props.activityFilters.sort!;
                    this.setState({ filters: _filters, isLoading: false });

                    this.getActivities(_filters);

                    this.triggerGetCoursContent();
                }
            }
        }, 3000);
    };

    public clickToDownload = async (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            await _common.DownloadLink(filepath + '/download', fileName);

            this.props.dispatch(
                enrollmentAddActionLog({
                    ActivityCompletionType: ActivityCompletionType.DownloadAttachment,
                    ActivityId: this.props.activityCard!.activityId!,
                    EnrollmentId: this.props.activityCard!.enrollmentId!,
                    ClassId: this.props.classId
                })
            );
        }

    };

    public clickToView = async (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();

        if (filepath && fileName) {
            this.setState({ selectedFile: { name: fileName, path: filepath }, isModalOpen: true })
        } else {
            Notification.setNotification('error', T.t('r_fileUpload_error'), 'topRight');
        }
    };

    setClosePrivewModal = () => {
        this.setState({ selectedFilePath: {}, isModalOpen: false })
    }

    afterSave() {
        this.props.dispatch(getCourseContentsWeekActivitiesAction(
            this.props.coursePageClassId ? this.props.coursePageClassId : '0',
            this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
            this.props.weekOrUnitId !== '0',
            0,
            1000,
            this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
            false,
            false,
            null,
            'contentWeekActivities',
            'get', undefined,this.props.sortKey ?? "-"));
    }

    public handleSave = (name: string) => {
        if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
            this.props.dispatch(
                SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
            );

            const shortenedName = name.length > maxEditTextLength
                ? name.slice(0, maxEditTextLength) + '...'
                : name;

            this.setState({
                editTextValue: shortenedName,
                editTextHandleValue: name
            });
        }
    };

    // public handleSave = (name: any) => {
    //     if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
    //         this.props.dispatch(
    //             SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
    //         );
    //         this.setState({
    //             editTextValue: name.length > maxEditTextLength
    //                 ? name.slice(0, maxEditTextLength).toString() + '...'
    //                 : name.toString(), editTextHandleValue: name
    //         });
    //     }
    // };

    // public handleSave = (name: any) => {
    //     if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
    //         this.props.dispatch(
    //             SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
    //         );
    //         this.setState({
    //             editTextValue: name.length > maxEditTextLength
    //                 ? name.slice(0, maxEditTextLength).toString() + '...'
    //                 : name.toString(), editTextHandleValue: name
    //         });
    //     }
    // };

    public handleClick(value: string) {
        this.setState({ editTextValue: value });
    };

    checkPrerequisite = () => {
        let isPrerequisiteCompleted = false
        if (this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student) {
            if (this.props.enrollmentData) {
                let prerequisiteActivities = this.props.enrollmentData.filter(f => f.activityId === this.props.activityCard!.prerequisiteActivityId)
                if (prerequisiteActivities.length > 0) {
                    if (prerequisiteActivities[0].status === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                        isPrerequisiteCompleted = true;

                    }
                }

            }
        }
        return isPrerequisiteCompleted;
    }

    renderActivityFile = (isCompletedPrerequisiteActivity: boolean) => {
        let fileContent;
        if (!isCompletedPrerequisiteActivity && this.props.activityCard?.prerequisiteActivityId && this.props.userType === UserType.Student) {
            fileContent = '';
        }
        else {
            fileContent = '';
            if (this.props.activityCard?.file) {
                fileContent = <div className="row file-upload-section" style={{ padding: '0px 38px 12px 38px' }}>
                    <span className="upload-title" tabIndex={0}>{T.t('r_activity_attachments2')}</span>
                    {this.props.activityCard.file.map((file: any, fileIndex: any) => {
                        return (
                            <div className="upload-file-temp" key={file.fileId}>
                                <button
                                    style={{ cursor: 'pointer', lineHeight: 1.3, overflow: 'hidden', whiteSpace: 'pre-line', textOverflow: 'ellipsis', border: 'none', background: 'none', textAlign: 'start', width: "100%" }}
                                    data-filename={file?.fileName}
                                    data-filepath={file?.filePath}
                                    onClick={this.clickToDownload}
                                    title={file.fileName}
                                    className="upload-file-name mobile-files web-files"
                                    tabIndex={0}

                                >
                                    <img src={_common.GetDefaultIcons('blueattach')} className="mx-3" alt="" />
                                    <span> {file.fileName}</span>
                                </button>
                                <div className="upload-desc d-flex justify-content-end gap-1">
                                    <button
                                        className="category-tag-square tag-gray mx-1"
                                        onClick={this.clickToDownload}
                                        data-filename={file?.fileName}
                                        data-filepath={file?.filePath}
                                    >
                                        <i className="material-icons mr-2">cloud_download</i>
                                        {T.t('r_download')}
                                    </button>

                                    {file.contentType == "application/pdf" &&
                                        <button
                                            className="category-tag-square tag-gray mx-1"
                                            onClick={this.clickToView}
                                            data-filename={file?.fileName}
                                            data-filepath={file?.filePath}
                                        >
                                            <i className="material-icons mr-2">visibility</i>
                                            {T.t('r_preview')}
                                        </button>
                                    }
                                </div>
                            </div>
                        );
                    })}

                </div>
            }
        }
        return fileContent;
    }

    renderPrerequisiteBody = (isCompletedPrerequisiteActivity: boolean) => {
        return (
            !isCompletedPrerequisiteActivity && this.props.activityCard?.prerequisiteActivityId && this.props.userType === UserType.Student ?
                <>
                    <hr className="bottom-border-2" />
                    <div className='row' style={{
                        opacity: 0.5, flexDirection: 'column',
                        fontSize: '1em !important',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                    }}>
                        <i className="material-icons" style={{ fontSize: '96px', marginTop: '10px' }}>lock</i>
                        <h5 className="font-medium" style={{ padding: '0 1.5em' }}>
                            {T.t('r_activity_restriction_by_another_message').replace('{0}', this.props.activityCard?.name).replace('{1}', this.props.activityCard?.prerequisiteActivityName)}
                        </h5>
                    </div>
                </>
                : ''
        )
    }

    renderFooter = (isCompletedPrerequisiteActivity: boolean) => {
        let renderFooterContent;

        if (!isCompletedPrerequisiteActivity && this.props.activityCard?.prerequisiteActivityId && this.props.userType === UserType.Student) {
            renderFooterContent = '';
        }
        else {
            renderFooterContent = '';
            if (this.props.userType === UserType.Student) {
                if (this.props.activityCard?.enrollmentStatus === enrollmentStatus.Completed) {
                    renderFooterContent =
                    <div className='success-btn-div'>
                    <button onClick={this.clickViewComplete} className="success-btn ml-auto mr-3">
                        {T.t('r_gen_enrollment_completed2')}
                    </button></div>
                }
                else {
                    renderFooterContent = <div className='success-btn-div'><button onClick={this.clickViewComplete} className="success-btn ml-auto mr-3">
                        {T.t('r_activity_complete')}
                    </button></div>
                }
            }
        }
        return renderFooterContent;
    }

    renderCardHeader = () => {
        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let activityDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : null;

        return (
            <div className="card-header">
                <div className={"activity-title "+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')}>
                    <img
                        src={_common.GetActivityTypeIcons('document')}
                        alt="Document Activity Icon"
                    />
                    {Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ? (
                        <div title={this.props.activityCard?.name} className="visible">
                            <EdiText
                                type="text"
                                onSave={this.handleSave}
                                onCancel={event => this.handleClick(this.state.editTextValue.length > maxEditTextLength
                                    ? this.state.editTextValue.slice(0, maxEditTextLength).toString() + '...'
                                    : this.state.editTextValue.toString())}
                                onEditingStart={event => this.handleClick(this.state.editTextHandleValue)}
                                value={this.state.editTextValue}
                                showButtonsOnHover={true}
                                saveButtonClassName="hideEditextSaveButton"
                                cancelButtonClassName="hideEditextCancelButton"
                                validationMessage={T.t('r_forum_tree_character')}
                                // tslint:disable-next-line:jsx-no-lambda
                                validation={val => val.trim().length >= 3}
                                editOnViewClick={true}
                                submitOnEnter={true}
                                cancelOnEscape={true}
                                className={'font-weight-bold mobile-activity-title web-activity-title'+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
                                tabIndex={0}
                            />
                        </div>
                    ) : (
                        <div title={this.props.activityCard?.name} className={"visible mobile-activity-title web-activity-title" + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} style={{ cursor: 'pointer', lineHeight: 1.3, whiteSpace: 'pre-line', textOverflow: 'ellipsis' }}>
                            {this.props.activityCard?.name && <Truncater length={42} text={this.props.activityCard?.name}></Truncater>}
                        </div>
                    )}

                    <ProcessingActivity
                        externalCssClassName="show_on_mobile"
                        activityId={this.props.activityCard?.activityId}
                        activityType={this.props.activityCard?.activityType}
                    />

                </div>
                <div className="activity-status">
                    {this.props.activityCard?.alwaysOnTop ? <span className="pinned"></span> : ''}
                    <span className="badges badges-document activity-type" tabIndex={0}>{T.t('r_activity_type_Document')}</span>
                    {/* <h6 style={{ margin: 'auto' }}>{this.props.activityCard?.alwaysOnTop ? '📍' : ''}</h6> */}
                    {this.props.activityCard?.taskDeadLine ? (
                        <div
                            className="last-date"
                            style={{ paddingRight: '20px' }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={T.t('r_activity_deadline')}
                        >
                            <Tooltip data={T.t('r_activity_deadline') +': '+ Moment(this.props.activityCard?.taskDeadLine).format(
                                    _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 3)
                                )} position='top' >

                            <span>
                                <i className="material-icons mr-1 text-warning">calendar_today</i>

                            </span>
                            </Tooltip>
                        </div>
                    ) : (
                        ''
                    )}
                    {this.props.userType === UserType.Student ? (
                        <ProgressCircleStudent enrollmentStatus={activityEnrollmentStatus ?? enrollmentStatus.NotStarted} deadline={activityDeadline} activityCard={this.props.activityCard} />
                    ) : (
                        <ProgressCircle activityCard={this.props.activityCard} percent={this.props.activityCard?.completedUser === 0 ? 0 : ((this.props.activityCard?.completedUser! * 100) / this.props.activityCard?.totalEnrollUser!)} />
                    )}
                    &nbsp;
                    <ProcessingActivity
                        externalCssClassName="hide_on_mobile"
                        activityId={this.props.activityCard?.activityId}
                        activityType={this.props.activityCard?.activityType}
                    />
                </div>
            </div>
        )

    }

    renderDescription = () => {
        return (
            (this.props.activityCard?.description && _common.removeHtmlTags(this.props.activityCard!.description).length > 0) ? (
                <div className="row ">
                    {
                        <div className="col d-flex justify-content-start align-items-baseline new-activity-block" >
                            <img src={_common.GetDefaultIcons('infoicon')} className="mr-2" alt="" />
                            <p className="card-info-text card-info-text-width mobile-activity-description">
                                <b>{T.t('r_add_exam_teacher_note')}</b>{' '}
                                <span id='instructor_note' className={(!_common.isArabic(this.props.activityCard!.description, document.body.getAttribute('dir')) ? 'arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.activityCard.description }}></span>
                            </p>
                        </div>}

                </div>

            ) : (
                ''
            )
        )
    }




    public render() {
        let isCompletedPrerequisiteActivity: boolean = this.checkPrerequisite();

        return this.props.activityCard ? (
            <div className="col-12 mobile-padding card-width" >
                <div className={this.props.activityCard.activeStatus === 0 ? 'card new-activity border-pasif' : 'card new-activity'}>
                    {this.renderCardHeader()}
                    {this.renderPrerequisiteBody(isCompletedPrerequisiteActivity)}
                    <hr className="bottom-border-2" />
                    <div className="card-body">
                        {this.renderDescription()}
                    </div>
                    {this.renderActivityFile(isCompletedPrerequisiteActivity)}
                    {this.renderFooter(isCompletedPrerequisiteActivity)}
                    <PdfPreview
                        modalIsOpen={this.state.isModalOpen}
                        selectedFile={this.state.selectedFile}
                        setCloseModal={this.setClosePrivewModal}
                    />

                </div>

            </div>
        ) : (
            <h4>{T.t('r_activity_was_not_found')}</h4>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        userPreferences: state.profile.userPreferences.preferences,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        activityCards: state.coursePage.activityCard,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        activityFilters: state.coursePage.activityFilters,
        enrollmentData: state.enrollment.enrollmentData,
        courseDefaultView: state.coursePage.courseDefaultView,
        sortKey: state.coursePage.courseSortingKey
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CDocumentActivityCard = connect(
    mapStateToProps,
    dispatchProps, null, { areStatesEqual }
)(DocumentActivityCard);

export default CDocumentActivityCard;
